import { PHASE } from "../../routeConfig";
import useAppSelector from "../../hooks/useAppSelector";
export default function useUnlinkedApplicationCompleteNextRoute(policyType) {
    if (policyType === void 0) { policyType = "auto"; }
    var isSavvyAgent = useAppSelector(function (state) { return state.configuration.isSavvyAgent; });
    if (isSavvyAgent) {
        return PHASE.AGENT_SUCCESS;
    }
    return PHASE.QUOTE_LOADING;
}
